import { Tabs, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { CADENCE_LABEL } from './lib/helpers'
import type { PlanCadence } from './lib/planChange.types'

export interface CadenceToggleProps {
  cadences: readonly PlanCadence[]
  selected: PlanCadence
  onSelect: (cadence: PlanCadence) => void
  savingsHint?: string | null
}

const isCadence = (
  value: string,
  cadences: readonly PlanCadence[]
): value is PlanCadence => cadences.some((cadence) => cadence === value)

export const CadenceToggle = ({
  cadences,
  selected,
  onSelect,
  savingsHint,
}: CadenceToggleProps) => {
  if (cadences.length < 2) return null

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Tabs
        value={selected}
        onValueChange={(value) => {
          if (isCadence(value, cadences)) onSelect(value)
        }}
      >
        <Tabs.List className="w-auto" aria-label="Billing schedule">
          {cadences.map((cadence) => (
            <Tabs.Trigger key={cadence} value={cadence} className="px-5">
              {CADENCE_LABEL[cadence]}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {cadences.map((cadence) => (
          <Tabs.Content key={cadence} value={cadence} className="hidden" />
        ))}
      </Tabs>
      {savingsHint && (
        <Text
          variant={TypographyStyles.BODY_SM}
          className="font-medium text-green-100"
        >
          {savingsHint}
        </Text>
      )}
    </div>
  )
}
